import * as React from 'react';
import { useFormState } from 'react-final-form';
import { DateFieldProps, DateField } from '../Date/Date';
import { Collapse } from '@mui/material';

interface Props {
	checkFieldIsRequired: (allValues: object) => boolean;
}

const DocExpiryDate: React.FC<DateFieldProps & Props> = ({ checkFieldIsRequired, ...props }) => {
	const { values } = useFormState();
	const isRequired = checkFieldIsRequired(values);
	const label = isRequired ? `${props.label}*` : props.label;
	const disabled = !isRequired || props.disabled;

	const needToDisplay = React.useMemo(() => {
		return isRequired || !!props.value;
	}, [isRequired, props.value]);

	if (props.disabled && !!props.value) {
		return <DateField {...props} disabled={true} label={label} />;
	} else {
		return (
			<Collapse className={props.className} in={needToDisplay}>
				<DateField {...props} disabled={disabled} label={label} />
			</Collapse>
		);
	}
};

export default DocExpiryDate;
